// Generated by ReScript, PLEASE EDIT WITH CARE

import * as OrderStage from "../../../ticket-dashboard/app/tickets/entities/OrderStage.bs.js";
import * as TicketRaisedBy from "../../../ticket-dashboard/app/tickets/entities/TicketRaisedBy.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as TicketBasicInfoApiModel from "../api-model/TicketBasicInfoApiModel.bs.js";

function apiModelToState(res) {
  return {
          msisdn: res.msisdn,
          crn: res.crn,
          location: res.location,
          caller_number: res.caller_number,
          order_stage: OrderStage.fromString(res.order_stage),
          raised_by: TicketRaisedBy.fromString(res.raised_by),
          crt_id: res.crt_id,
          callback_language: res.callback_language
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(TicketBasicInfoApiModel.t_decode(json), "TicketBasicInfoEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
